import React, {  useState } from 'react';
import { Select } from 'antd';
import styles from './styles';
import textStyles from '../rbh-text/styles';
import { FormattedMessage } from 'react-intl';

export const RBHSelect = (p: any) => {
  if (p.variant === 'outlined') {
    return OutlinedRBHSelect(p)
  }
  return (
    <Select size='large' {...p}
      style={{...styles.selectDefault, ...textStyles.formText, ...p.style}}
      placeholder={ p.placeholder ? <FormattedMessage id={p.placeholder} /> : ''}
    >
      {p.children}
    </Select>
  );
};

const OutlinedRBHSelect = (props: any) => {
  const [focus, setFocus] = useState(false);
    const isOccupied = focus || props.value;
    let labelStyle: any = isOccupied ? {...styles.outlinedPlaceholder, ...styles.outlinedLabel } : {...styles.outlinedPlaceholder}
    if (isOccupied) {
      const bgColor = isOccupied && props.disabled ? styles.outlinedGradientLinear : styles.outlinedWhiteBg
      labelStyle = {...labelStyle, ...bgColor}
    }
  return (
    <div onFocus={() => setFocus(true)} onBlur={() => setFocus(false)} style={{position: 'relative'}}>
      <Select size='large' {...props}
        style={{...styles.selectDefault, ...textStyles.formText, ...props.style}}
        placeholder={ props.placeholder ? <FormattedMessage id={props.placeholder} /> : ''}
      >
        {props.children}
      </Select>
      <label style={labelStyle}>{props.label}</label>
    </div>
  )

}

export default RBHSelect;
